import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import SurveyResultsPage from 'components/pages/SurveyResults';

import pageTitles from 'utils/pageTitles';
import getRouteState from 'utils/getRouteState';
import { historyShape } from 'utils/shapes/router.shapes';
import { setTitle, setActiveMenuItem } from 'containers/store';

import {
  loadPageData, onChangeSort, onChangePage, onChangeRowsPerPage, onEditData, onDownload,
} from './store';

class SurveyResults extends React.Component {
  static propTypes = {
    history: historyShape.isRequired,
    intl: intlShape.isRequired,
    isLoadedPage: PropTypes.bool.isRequired,
    loadPageData: PropTypes.func.isRequired,
    setActiveMenuItem: PropTypes.func.isRequired,
    setTitle: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.setTitle(this.props.intl.formatMessage(pageTitles.surveyResults));
    this.props.setActiveMenuItem('surveysResults');
    const routeState = getRouteState(this.props.history);
    this.props.loadPageData(routeState);
  }

  render() {
    return this.props.isLoadedPage ? (
      <SurveyResultsPage
        {...this.props}
      />
    ) : null;
  }
}

const mapDispatchToProps = {
  setTitle,
  setActiveMenuItem,
  loadPageData,
  onChangeSort,
  onChangePage,
  onChangeRowsPerPage,
  onEditData,
  onDownload,
};

const mapStateToProps = (state) => ({
  ...state.SurveyResults,
  ...state.Global.pagingData,
  totalItemsCount: state.SurveyResults.totalItemsCount,
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(SurveyResults)));
